import * as UrlConstants from '@/constants/url-constants'
import * as StorageConstants from '@/constants/storage-constants'
import WebglCompatibilityService from '@/services/Three/webgl-compatibility.service'
import Analytics from '@/singletons/analytics'
import SentrySingleton from '@/singletons/sentry-singleton'

export default class ModeDetermineService {
    determineFullorder(): boolean {
        let local: any = null
        try {
            local = localStorage.getItem(StorageConstants.renderingmode)
        }
        catch (err) {
            // on some browser like LINE, there is no localstorage; ignore that error
            console.error(err)
        }

        try {
            const urlParams = new URLSearchParams(window.location.search)
            if (urlParams.has(UrlConstants.renderingmode) && urlParams.get(UrlConstants.renderingmode) == 'true') {
                return false
            }
            if (local && JSON.parse(local) === true) {
                return false
            }
            if (WebglCompatibilityService.isWebGLAvailable()) {
                Analytics.instance.sendThreejsNotAvailableErrorEvent(navigator.userAgent)
                return true
            }
            return false
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return false
        }
    }

    determineVieworder(): boolean {
        try {
            if (!WebglCompatibilityService.isWebGLAvailable()) {
                Analytics.instance.sendThreejsNotAvailableErrorEvent(navigator.userAgent)
                return false
            }
            const urlParams = new URLSearchParams(window.location.search)
            if (urlParams.has(UrlConstants.renderingmode) && urlParams.get(UrlConstants.renderingmode) == 'true') {
                return false
            }
            return true
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return true
        }
    }
}